import { render } from "./EntryUpload.vue?vue&type=template&id=628c7398&scoped=true"
import script from "./EntryUpload.vue?vue&type=script&lang=js"
export * from "./EntryUpload.vue?vue&type=script&lang=js"

import "./EntryUpload.vue?vue&type=style&index=0&id=628c7398&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628c7398"]])

export default __exports__